import { render, staticRenderFns } from "./proposalFeeDetail.vue?vue&type=template&id=ad1b0136&scoped=true"
import script from "./proposalFeeDetail.vue?vue&type=script&lang=js"
export * from "./proposalFeeDetail.vue?vue&type=script&lang=js"
import style0 from "./proposalFeeDetail.vue?vue&type=style&index=0&id=ad1b0136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1b0136",
  null
  
)

export default component.exports